<!-- @format -->

<ng-container *transloco="let t">
  <dl class="d-flex flex-wrap" aria-live="polite" aria-atomic="true">
    <div class="tiny-static-form-group sis-mr-xs">
      <dt class="label colon">{{ t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.FIELDS.RULE") }}</dt>
      @if (allMandatory()) {
        <dd class="value" [attr.id]="ruleLegendId">{{ t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.RULE_CLAUSES.CHOOSE_ALL") }} </dd>
      }
      @if (!allMandatory() && ruleRequireRange()) {
        <dd class="value" [attr.id]="ruleLegendId"
          >{{
            t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.RULE_CLAUSES.CHOOSE") +
              " " +
              (ruleRequireRange() | translateRange) +
              " " +
              t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.RULE_CLAUSES.PCS")
          }}
        </dd>
      }
    </div>
    @if (!onlyShowRule) {
      @if (ruleRequireRange()) {
        <div class="tiny-static-form-group sis-mr-xs">
          <dt class="label colon">{{ t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.FIELDS.CHOSEN") }}</dt>
          <dd class="value"
            >{{
              selectedCount() +
                "/" +
                (ruleRequireRange() | translateRange) +
                " " +
                t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.RULE_CLAUSES.PCS")
            }}
          </dd>
        </div>
      }
      <div id="validation-state" class="tiny-static-form-group">
        <dt class="label colon">{{ t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.FIELDS.STATE") }}</dt>
        @if (rangeValidationResultState() !== "OK" && rangeValidationResultState() !== "IMPLICIT_OK") {
          <dd class="value">{{ t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.STATES." + rangeValidationResultState()) ?? "-" }} </dd>
        } @else {
          <dd class="value">{{ t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.STATES." + planValidationState()) }}</dd>
        }
      </div>
    }
  </dl>
</ng-container>
